"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNORDERED_LIST_ITEM = exports.LINK = exports.BOLD = exports.HEADER_ONE = void 0;
exports.HEADER_ONE = 'header-one';
exports.BOLD = 'BOLD';
exports.LINK = 'LINK';
exports.UNORDERED_LIST_ITEM = 'unordered-list-item';
//# sourceMappingURL=editor.js.map